import styled from 'styled-components'

const MenuItemCollapseStyle = styled.li`
    --collapsePadding: var(--sp3x);
    --collapseMarginBottom: var(--sp2x);
    --toggleIconSize: var(--sp3x);
    --linkItemWidth: 50%;
    --linkItemPaddingH: var(--sp3x);
    --linkItemMarginBottom: var(--sp4x);

    background: var(--primaryColor3);
    padding: var(--collapsePadding);
    margin-bottom: var(--collapseMarginBottom);
    border-radius: var(--sp1x);

    .collapse-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .comp-title {
            text-transform: uppercase;
        }

        .toggle-icon {
            position: relative;
            width: var(--toggleIconSize);
            height: var(--toggleIconSize);

            &:before,
            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                right: 0;
                height: 2px;
                background: var(--primaryColor1);
            }

            &:before {
                transform: translateY(-50%);
            }

            &:after {
                transform: rotate(90deg) translateX(-1px);
                transition: transform var(--trTime);
            }
        }
    }

    .collapse-body-cont {
        overflow: hidden;
        
        .collapse-body {
            display: flex;
            flex-wrap: wrap;
            margin: 0 calc(var(--linkItemPaddingH) * -1) calc(var(--linkItemMarginBottom) * -1);
            padding-top: var(--collapsePadding);
            
            .link-item-cont {
                width: var(--linkItemWidth);
                padding: 0 var(--linkItemPaddingH);
                margin-bottom: var(--linkItemMarginBottom);
                color: var(--secondaryColor2);

                .link-item {
                    line-height: 1;
                }

                &.active {
                    color: var(--primaryColor1);
                    pointer-events: none;
                }
            }
        }
    }

    &.active {
        .toggle-icon {
            &:after {
                transform: rotate(0) translateY(-50%);
            }
        }
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --collapsePadding: var(--sp2x);
        --toggleIconSize: var(--sp2x);
        --linkItemPaddingH: var(--sp2x);
        --linkItemMarginBottom: var(--sp2x);
        --linkItemWidth: 100%;
    }

`

export default MenuItemCollapseStyle